export const organizationEndpoints = {
  getOrganization: "/org",
};
